import React from "react";

type TimeRange = "1d" | "7d" | "1m" | "6m" | "1y";

const TIME_RANGES = [
  { key: "1d" as TimeRange, label: "Day" },
  { key: "7d" as TimeRange, label: "Week" },
  { key: "1m" as TimeRange, label: "Month" },
  { key: "6m" as TimeRange, label: "6 Month" },
  { key: "1y" as TimeRange, label: "Year" },
];

interface TimeRangeSelectorProps {
  selectedRange: TimeRange;
  setSelectedRange: (range: TimeRange) => void;
}

export const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({
  selectedRange,
  setSelectedRange,
}) => {
  return (
    <div className="flex justify-center p-4">
      {/* Time Range Tabs */}
      <div className="flex rounded-lg bg-gray-900 p-1">
        {TIME_RANGES.map((range) => (
          <button
            key={range.key}
            onClick={() => setSelectedRange(range.key)}
            className={`rounded-md px-4 py-2 text-sm font-medium transition-colors ${
              selectedRange === range.key
                ? "bg-gray-700 text-white"
                : "text-gray-400 hover:text-white"
            }`}
          >
            {range.label}
          </button>
        ))}
      </div>
    </div>
  );
};
